//import Leads from "../components/leads/Leads";

class ServicesConfig {
    baseUrl = "http://localhost:3100/";
}

export default new ServicesConfig()

